export const USER_TOKEN_KEY = 'arco-admin-token'
export const USER_INFO_KEY = 'arco-user-info'
export const APP_SETTING_INFO = 'arco-setting-info'
export const USER_BUSINESS_INFO = 'arco-user-business-info'
